import { useRouteError } from 'react-router-dom';
import { ehModuloAusente } from '@shared/lib/novaVersao';

/**
 * Mostra o erro REAL de uma rota, em vez da tela generica do React
 * Router.
 *
 * Existe porque "Unexpected Application Error! Cannot convert object to
 * primitive value" nao diz onde nem o que -- e o stack aponta so para o
 * runtime do React. Aqui o objeto do erro e inspecionado antes de virar
 * texto, que e justamente o que falha na tela padrao.
 */
export function LimiteErro() {
  const erro = useRouteError() as unknown;

  // Pedaço do app de uma versão anterior: não é bug, é deploy novo com a
  // aba aberta. Normalmente a página já recarregou sozinha (main.tsx); se
  // chegou aqui, a recarga automática já foi gasta -- fica o botão.
  if (ehModuloAusente(erro)) {
    return (
      <div style={{ padding: 32, maxWidth: 520 }}>
        <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 10 }}>
          Nova versão publicada
        </h1>
        <p style={{ fontSize: 'var(--fs-corpo)', color: 'var(--text-2)', lineHeight: 1.6 }}>
          A plataforma foi atualizada enquanto esta aba estava aberta.
          Recarregue a página para continuar.
        </p>
        <button type="button" onClick={() => window.location.reload()}
                style={{
                  marginTop: 18, padding: '11px 22px', borderRadius: 'var(--r-pill)',
                  background: 'var(--yellow)', color: 'var(--sobre-primaria)',
                  fontFamily: 'inherit', fontSize: 14, fontWeight: 500, cursor: 'pointer',
                }}>
          Recarregar
        </button>
      </div>
    );
  }

  let titulo = 'Erro inesperado';
  let detalhe = '';
  let pilha = '';

  if (erro instanceof Error) {
    titulo = erro.name || 'Error';
    detalhe = erro.message;
    pilha = erro.stack ?? '';
  } else if (erro && typeof erro === 'object') {
    // Nao usa String(erro): se o objeto nao tem toString, e exatamente
    // isso que estoura com "Cannot convert object to primitive value".
    try {
      detalhe = JSON.stringify(erro, Object.getOwnPropertyNames(erro), 2);
    } catch {
      detalhe = Object.prototype.toString.call(erro);
    }
  } else {
    detalhe = Object.prototype.toString.call(erro);
  }

  return (
    <div style={{ padding: 32, fontFamily: 'var(--mono)', fontSize: 13 }}>
      <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 10 }}>{titulo}</h1>
      <pre style={{
        whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        background: 'var(--stale-bg)', padding: 14, borderRadius: 12,
      }}>{detalhe}</pre>
      {pilha && (
        <pre style={{
          whiteSpace: 'pre-wrap', fontSize: 11, color: 'var(--muted)',
          marginTop: 12, maxHeight: 320, overflow: 'auto',
        }}>{pilha}</pre>
      )}
    </div>
  );
}
